module.exports = __webpack_public_path__ + "static/media/16_tn.05e79b6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/16_tn.jpg
// module id = 504
// module chunks = 0